import React, { useEffect, useRef } from "react";
import { Eraser } from "lucide-react";

export const SignaturePad = ({ onChange, testId = "signature-pad" }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const dirty = useRef(false);

  useEffect(() => {
    const c = ref.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#022E5D";
  }, []);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    return [e.clientX - r.left, e.clientY - r.top];
  };
  const start = (e) => {
    e.preventDefault();
    ref.current.setPointerCapture(e.pointerId);
    drawing.current = true;
    const ctx = ref.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = ref.current.getContext("2d");
    ctx.lineTo(...pos(e));
    ctx.stroke();
    dirty.current = true;
  };
  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    if (!dirty.current) return;
    const out = document.createElement("canvas");
    out.width = 420; out.height = Math.round(420 * ref.current.height / ref.current.width);
    out.getContext("2d").drawImage(ref.current, 0, 0, out.width, out.height);
    onChange(out.toDataURL("image/png"));
  };
  const clear = () => {
    const c = ref.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    dirty.current = false;
    onChange(null);
  };

  return (
    <div>
      <canvas
        ref={ref}
        data-testid={testId}
        onPointerDown={start}
        onPointerMove={move}
        onPointerUp={end}
        onPointerLeave={end}
        className="w-full h-36 bg-white border-2 border-dashed border-slate-300 rounded-xl touch-none cursor-crosshair"
      />
      <div className="flex items-center justify-between mt-1.5">
        <span className="text-xs text-slate-500">Firma qui con il dito o il mouse</span>
        <button type="button" data-testid={`${testId}-clear`} onClick={clear} className="text-xs text-slate-600 hover:text-navy flex items-center gap-1"><Eraser className="w-3.5 h-3.5"/>Cancella</button>
      </div>
    </div>
  );
};
